import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { ApiStarMoneyAdapterService } from "./adapters/api-star-money-adapter.service";
import { StarMoneyAdapterService } from "./services/star-money-adapter.service";
import { StarMoneyFacadeService } from "./services/star-money-facade.service";
import { LocalStarMoneyAdapterService } from "./adapters/local-star-money-adapter.service";



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    // StoreModule.forFeature('StarMoney', StarMoneyReducer),
    // EffectsModule.forFeature([StarMoneyEffects]),
  ],
  providers: [
    {
      provide: StarMoneyAdapterService,
      useClass: ApiStarMoneyAdapterService,
      // useClass: LocalStarMoneyAdapterService
    },
    StarMoneyFacadeService,
  ],
})
export class StarMoneyDataModule { }
